module.exports = __webpack_public_path__ + "static/wojnaIdeiLogo-62f17057fa042a8061daf4b48b50fc41.svg";